<ng-container *ngIf="currentLaguageId$ | async; let currentLaguageId">
    <app-tag-chip-select
        class="w-100"
        placeholder="Add Tag"
        [language_id]="currentLaguageId"
        i18n-placeholder
        [formControl]="tags"
    ></app-tag-chip-select>
</ng-container>
